import React from "react";
import LoginForm from "../../components/features/auth/LoginForm";

const LoginPage = () => {
  return <LoginForm />;
};

export default LoginPage;
